import { CreateSpaceRequest, CreateSpaceResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const createSpace = makeCloudFunction<
  CreateSpaceRequest,
  CreateSpaceResponse
>("space", "createSpace");
